import React, { useRef } from 'react';
import { useScript } from '../hooks/useScript';
import './HoneyloveIRL.module.scss';

// eslint-disable-next-line max-lines-per-function
export const HoneyloveIRL = React.memo(() => {
  const containerRef = useRef(null);
  useScript(
    '//foursixty.com/media/scripts/fs.embed.v2.5.js',
    {
      'data-page-size': '12',
      'data-feed-id': 'honeylove',
      'data-theme': 'showcase_v2_5',
      'data-open-links-in-same-page': 'true',
      'data-connector-filter': '50931,50932',
    },
    containerRef?.current,
  );

  return <div ref={containerRef}></div>;
});
